import React from "react";
import Header from "./Header";
import Memegenerator from "./Memegenerator";
import "./style.css";

function App() {
  return (
    <>
      <Header />
      <Memegenerator />
    </>
  );
}

export default App;
